import { z } from 'zod';
import { channelKind, deliveryStatus, isoTimestamp, pageQuery, uuid } from './primitives.js';
export const delivery = z.object({
    id: uuid,
    alert_id: uuid,
    alert_title: z.string(),
    channel_id: uuid,
    channel_label: z.string(),
    channel_kind: channelKind,
    user_name: z.string(),
    route_id: uuid.nullable(),
    route_name: z.string().nullable(),
    status: deliveryStatus,
    attempts: z.number().int(),
    last_error: z.string().nullable(),
    provider_message_id: z.string().nullable(),
    next_attempt_at: isoTimestamp.nullable(),
    delivered_at: isoTimestamp.nullable(),
    created_at: isoTimestamp,
});
export const listDeliveriesQuery = pageQuery.extend({
    alert_id: uuid.optional(),
    channel_id: uuid.optional(),
    status: deliveryStatus.optional(),
});
//# sourceMappingURL=deliveries.js.map